var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{opacity:0.2;}.cls-3{fill:#535959;mix-blend-mode:multiply;}.cls-4{opacity:0.95;}.cls-5{fill:#fff;}"));

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("title", null, "img-path");

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  className: "cls-1"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M575.21,62.35a69.23,69.23,0,0,0,14.88-1.51A58.33,58.33,0,0,0,603.54,56c8.79-4.34,17.6-11.28,26.31-19.18,5-4.54,10.31-9.06,16.15-13.42a128.1,128.1,0,0,1,19.5-12.13A102.34,102.34,0,0,1,688.92,3a118.88,118.88,0,0,1,49,0,102.34,102.34,0,0,1,23.42,8.31,128.1,128.1,0,0,1,19.5,12.13C786.67,27.8,792,32.32,797,36.86c8.72,7.9,17.53,14.84,26.31,19.18a58.24,58.24,0,0,0,13.46,4.8,69.07,69.07,0,0,0,14.87,1.51,69.14,69.14,0,0,0,14.87-1.51A58,58,0,0,0,879.93,56c8.79-4.34,17.6-11.28,26.32-19.18,5-4.54,10.3-9.06,16.15-13.42a128,128,0,0,1,19.49-12.13A102.34,102.34,0,0,1,965.31,3,113.86,113.86,0,0,1,989.81.45H1149l.5,37.2H989.81a69.14,69.14,0,0,0-14.87,1.51A58.09,58.09,0,0,0,961.5,44c-8.79,4.35-17.6,11.3-26.32,19.2-5,4.54-10.31,9.06-16.16,13.42a127.72,127.72,0,0,1-19.51,12.13A102.05,102.05,0,0,1,876.1,97a113.77,113.77,0,0,1-24.49,2.55A113.77,113.77,0,0,1,827.12,97a102.3,102.3,0,0,1-23.42-8.29,128.7,128.7,0,0,1-19.51-12.13c-5.84-4.36-11.13-8.88-16.15-13.42-8.72-7.9-17.53-14.85-26.32-19.2a58.09,58.09,0,0,0-13.44-4.8,74,74,0,0,0-29.74,0A58.09,58.09,0,0,0,685.1,44c-8.79,4.35-17.6,11.3-26.32,19.2-5,4.54-10.31,9.06-16.15,13.42a128.7,128.7,0,0,1-19.51,12.13A102.3,102.3,0,0,1,599.7,97a113.7,113.7,0,0,1-24.49,2.55h-.42A113.7,113.7,0,0,1,550.3,97a102.3,102.3,0,0,1-23.42-8.29,128.7,128.7,0,0,1-19.51-12.13c-5.84-4.36-11.14-8.88-16.15-13.42-8.72-7.9-17.53-14.85-26.32-19.2a58.09,58.09,0,0,0-13.44-4.8,74,74,0,0,0-29.74,0A58.09,58.09,0,0,0,408.28,44c-8.79,4.35-17.6,11.3-26.32,19.2-5,4.54-10.31,9.06-16.15,13.42A128.7,128.7,0,0,1,346.3,88.71,102.3,102.3,0,0,1,322.88,97a113.77,113.77,0,0,1-24.49,2.55A113.77,113.77,0,0,1,273.9,97a102.05,102.05,0,0,1-23.41-8.29A127.72,127.72,0,0,1,231,76.58c-5.85-4.36-11.14-8.88-16.16-13.42-8.72-7.9-17.53-14.85-26.32-19.2a58.09,58.09,0,0,0-13.44-4.8,69.14,69.14,0,0,0-14.87-1.51H.49L1,.45h159.2A113.86,113.86,0,0,1,184.69,3a102.34,102.34,0,0,1,23.42,8.31A128,128,0,0,1,227.6,23.44c5.85,4.36,11.14,8.88,16.15,13.42,8.72,7.9,17.53,14.84,26.32,19.18a58,58,0,0,0,13.45,4.8,69.14,69.14,0,0,0,14.87,1.51,69.07,69.07,0,0,0,14.87-1.51A58.24,58.24,0,0,0,326.72,56C335.5,51.7,344.31,44.76,353,36.86c5-4.54,10.3-9.06,16.15-13.42a128.1,128.1,0,0,1,19.5-12.13A102.34,102.34,0,0,1,412.1,3a118.88,118.88,0,0,1,49,0,102.34,102.34,0,0,1,23.42,8.31A128.1,128.1,0,0,1,504,23.44c5.84,4.36,11.13,8.88,16.15,13.42,8.71,7.9,17.52,14.84,26.31,19.18a58.33,58.33,0,0,0,13.45,4.8,69.23,69.23,0,0,0,14.88,1.51"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M514,58.31l2.71,2.16c.89.74,1.84,1.41,2.76,2.11a.39.39,0,0,0,.51,0l.69-.77a.3.3,0,0,0-.08-.45c-.91-.7-1.85-1.36-2.73-2.09l-2.68-2.14a.39.39,0,0,0-.51,0l-.74.74A.31.31,0,0,0,514,58.31Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M526.41,67.45l3,1.87c1,.6,2,1.17,3.07,1.76a.37.37,0,0,0,.49-.07l.57-.86a.31.31,0,0,0-.15-.44c-1-.57-2-1.13-3-1.72l-2.93-1.85a.39.39,0,0,0-.5,0l-.64.81A.31.31,0,0,0,526.41,67.45Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M540.17,74.89l1.63.72c.55.23,1.12.43,1.68.64l1.67.63c.56.21,1.12.43,1.7.59a.37.37,0,0,0,.47-.17l.38-.94a.32.32,0,0,0-.25-.39c-.56-.16-1.1-.38-1.65-.58l-1.64-.61c-.55-.21-1.1-.4-1.64-.63l-1.59-.7a.39.39,0,0,0-.49.12l-.48.9A.32.32,0,0,0,540.17,74.89Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M571.17,81.66l3.62.09v-1.6l-3.56-.09a.36.36,0,0,0-.39.29l0,1C570.79,81.52,571,81.66,571.17,81.66Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M555.28,79.78l3.55.67.89.16c.3,0,.6.08.9.12l1.79.24c.21,0,.41-.09.43-.25l.15-1a.35.35,0,0,0-.33-.35l-1.76-.23L560,79l-.87-.16-3.47-.65a.35.35,0,0,0-.44.21l-.26,1A.32.32,0,0,0,555.28,79.78Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M440.14,19.94a.37.37,0,0,0,.4-.29l0-1a.34.34,0,0,0-.37-.31l-3.62-.09v1.6Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M448.72,20.62l1.76.23.87.11.87.17,3.48.65a.37.37,0,0,0,.44-.21l.26-1a.34.34,0,0,0-.3-.38l-3.55-.67-.89-.16c-.3-.05-.6-.08-.9-.12L449,19a.36.36,0,0,0-.42.25l-.15,1A.34.34,0,0,0,448.72,20.62Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M463.92,24a16.31,16.31,0,0,1,1.66.58l1.64.61c.54.21,1.09.4,1.63.62l1.6.71a.38.38,0,0,0,.48-.12l.48-.9a.33.33,0,0,0-.2-.43l-1.64-.71c-.55-.23-1.11-.43-1.67-.64l-1.68-.63c-.56-.21-1.11-.43-1.69-.6a.4.4,0,0,0-.48.17l-.37.94A.33.33,0,0,0,463.92,24Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M478,30.3c1,.57,2,1.14,3,1.72l2.93,1.85a.39.39,0,0,0,.5,0l.64-.82a.3.3,0,0,0-.12-.44l-3-1.88c-1-.6-2-1.17-3.06-1.76a.38.38,0,0,0-.5.07l-.57.86A.31.31,0,0,0,478,30.3Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M502.51,48.3l2.55,2.28,2.57,2.29a.39.39,0,0,0,.51,0l.76-.71a.31.31,0,0,0,0-.46l-2.55-2.28-2.58-2.29a.38.38,0,0,0-.5,0l-.77.71A.31.31,0,0,0,502.51,48.3Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M490.78,38.67c.91.7,1.85,1.36,2.73,2.09l2.68,2.14a.38.38,0,0,0,.5,0l.74-.74a.31.31,0,0,0-.07-.46l-2.7-2.16c-.89-.74-1.84-1.41-2.76-2.11a.39.39,0,0,0-.51,0l-.7.78A.31.31,0,0,0,490.78,38.67Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M634.4,57.12l-2.68,2.14c-.88.73-1.82,1.39-2.73,2.09a.3.3,0,0,0-.09.45l.7.77a.38.38,0,0,0,.5,0c.92-.7,1.88-1.37,2.77-2.11l2.7-2.16a.31.31,0,0,0,.07-.46l-.74-.74A.38.38,0,0,0,634.4,57.12Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M622.14,66.14,619.22,68c-1,.59-2,1.15-3,1.72a.32.32,0,0,0-.15.44l.57.86a.39.39,0,0,0,.5.07c1-.59,2-1.16,3.06-1.76l3-1.87a.31.31,0,0,0,.13-.45l-.65-.81A.39.39,0,0,0,622.14,66.14Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M608.65,73.45l-1.6.7c-.54.23-1.09.42-1.63.63l-1.64.61c-.55.2-1.09.42-1.66.58a.32.32,0,0,0-.24.39l.37.94a.39.39,0,0,0,.48.17c.58-.16,1.13-.38,1.69-.59l1.68-.63c.56-.21,1.12-.41,1.67-.64l1.64-.72a.31.31,0,0,0,.2-.42l-.48-.9A.37.37,0,0,0,608.65,73.45Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M578.34,80.06l-3.55.09v1.6l3.62-.09a.34.34,0,0,0,.37-.31l0-1C578.73,80.19,578.55,80.06,578.34,80.06Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M593.89,78.23l-3.47.65-.87.16-.88.11-1.75.23c-.21,0-.36.18-.33.35l.14,1a.38.38,0,0,0,.43.25l1.8-.24c.3,0,.6-.07.89-.12l.89-.16,3.56-.67a.32.32,0,0,0,.3-.37l-.26-1A.37.37,0,0,0,593.89,78.23Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M700.61,19l-1.79.24-.9.12-.89.16-3.56.67a.32.32,0,0,0-.29.38l.26,1c0,.16.23.24.44.21l3.47-.65.87-.17.88-.11,1.76-.23c.2,0,.35-.18.32-.35l-.14-1A.38.38,0,0,0,700.61,19Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M685.05,22.53c-.58.17-1.14.39-1.7.6l-1.68.63c-.55.21-1.12.41-1.67.64l-1.63.71a.33.33,0,0,0-.21.43l.48.9a.4.4,0,0,0,.49.12l1.59-.71c.54-.22,1.09-.41,1.64-.62l1.64-.61a17,17,0,0,1,1.65-.58c.2-.07.31-.24.25-.4l-.38-.94A.38.38,0,0,0,685.05,22.53Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M670.65,28.93c-1,.59-2,1.16-3.06,1.76l-3,1.88a.31.31,0,0,0-.13.44l.65.82a.39.39,0,0,0,.5,0L668.56,32c1-.58,2-1.15,3-1.72a.33.33,0,0,0,.15-.44l-.57-.86A.39.39,0,0,0,670.65,28.93Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M645.84,47.15l-2.57,2.29-2.56,2.28a.31.31,0,0,0,0,.46l.77.71a.38.38,0,0,0,.5,0l2.57-2.29,2.56-2.28a.31.31,0,0,0,0-.46l-.76-.71A.39.39,0,0,0,645.84,47.15Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M657.68,37.44c-.92.7-1.88,1.37-2.77,2.11l-2.7,2.16a.31.31,0,0,0-.07.46l.74.74a.39.39,0,0,0,.51,0l2.67-2.14c.89-.73,1.83-1.39,2.74-2.09a.3.3,0,0,0,.08-.45l-.7-.78A.38.38,0,0,0,657.68,37.44Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M237.61,58.31l2.7,2.16c.89.74,1.85,1.41,2.77,2.11a.38.38,0,0,0,.5,0l.7-.77a.3.3,0,0,0-.09-.45c-.91-.7-1.85-1.36-2.73-2.09l-2.68-2.14a.38.38,0,0,0-.5,0l-.74.74A.31.31,0,0,0,237.61,58.31Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M250,67.45l3,1.87c1,.6,2,1.17,3.06,1.76a.39.39,0,0,0,.5-.07l.57-.86a.33.33,0,0,0-.15-.44c-1-.57-2-1.13-3-1.72L251,66.14a.39.39,0,0,0-.5,0l-.65.81A.31.31,0,0,0,250,67.45Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M263.77,74.89l1.63.72c.56.23,1.12.43,1.68.64l1.68.63c.56.21,1.11.43,1.69.59a.39.39,0,0,0,.48-.17l.37-.94a.32.32,0,0,0-.24-.39c-.57-.16-1.11-.38-1.66-.58l-1.64-.61c-.54-.21-1.09-.4-1.63-.63l-1.6-.7a.37.37,0,0,0-.48.12l-.48.9A.31.31,0,0,0,263.77,74.89Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M294.77,81.66l3.62.09v-1.6l-3.55-.09a.37.37,0,0,0-.4.29l0,1A.34.34,0,0,0,294.77,81.66Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M278.88,79.78l3.56.67.88.16.9.12L286,81a.36.36,0,0,0,.42-.25l.15-1c0-.17-.12-.32-.33-.35l-1.76-.23-.87-.11-.87-.16-3.48-.65a.35.35,0,0,0-.44.21l-.26,1A.32.32,0,0,0,278.88,79.78Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M163.75,19.94a.36.36,0,0,0,.39-.29l.05-1a.34.34,0,0,0-.38-.31l-3.62-.09v1.6Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M172.32,20.62l1.76.23L175,21l.87.17,3.47.65a.37.37,0,0,0,.44-.21l.26-1a.34.34,0,0,0-.3-.38l-3.55-.67-.89-.16c-.3-.05-.6-.08-.9-.12L172.57,19a.38.38,0,0,0-.43.25l-.15,1A.35.35,0,0,0,172.32,20.62Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M187.53,24a17,17,0,0,1,1.65.58l1.64.61c.54.21,1.1.4,1.63.62l1.6.71a.4.4,0,0,0,.49-.12l.48-.9a.34.34,0,0,0-.21-.43l-1.63-.71c-.55-.23-1.12-.43-1.68-.64l-1.67-.63c-.57-.21-1.12-.43-1.7-.6a.38.38,0,0,0-.47.17l-.38.94C187.22,23.8,187.33,24,187.53,24Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M201.61,30.3c1,.57,2,1.14,3,1.72l2.92,1.85a.39.39,0,0,0,.5,0l.65-.82a.31.31,0,0,0-.13-.44l-3-1.88c-1-.6-2-1.17-3.06-1.76a.39.39,0,0,0-.5.07l-.57.86A.32.32,0,0,0,201.61,30.3Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M226.11,48.3l2.55,2.28,2.58,2.29a.38.38,0,0,0,.5,0l.77-.71a.31.31,0,0,0,0-.46l-2.55-2.28-2.57-2.29a.39.39,0,0,0-.51,0l-.76.71A.31.31,0,0,0,226.11,48.3Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M214.38,38.67c.91.7,1.85,1.36,2.73,2.09l2.68,2.14a.39.39,0,0,0,.51,0l.73-.74a.3.3,0,0,0-.06-.46l-2.71-2.16c-.89-.74-1.84-1.41-2.76-2.11a.39.39,0,0,0-.51,0l-.69.78A.3.3,0,0,0,214.38,38.67Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M358,57.12l-2.68,2.14c-.88.73-1.82,1.39-2.73,2.09a.31.31,0,0,0-.09.45l.7.77a.39.39,0,0,0,.51,0c.92-.7,1.87-1.37,2.76-2.11l2.71-2.16a.3.3,0,0,0,.06-.46l-.73-.74A.39.39,0,0,0,358,57.12Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M345.75,66.14,342.82,68c-1,.59-2,1.15-3,1.72a.31.31,0,0,0-.14.44l.56.86a.39.39,0,0,0,.5.07c1-.59,2-1.16,3.07-1.76l3-1.87a.31.31,0,0,0,.12-.45l-.64-.81A.39.39,0,0,0,345.75,66.14Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M332.25,73.45l-1.59.7c-.54.23-1.1.42-1.64.63l-1.64.61c-.55.2-1.09.42-1.65.58a.32.32,0,0,0-.25.39l.37.94a.39.39,0,0,0,.48.17c.58-.16,1.13-.38,1.7-.59l1.67-.63c.56-.21,1.13-.41,1.68-.64l1.63-.72a.31.31,0,0,0,.2-.42l-.47-.9A.39.39,0,0,0,332.25,73.45Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M301.94,80.06l-3.55.09v1.6l3.62-.09a.34.34,0,0,0,.37-.31l0-1A.37.37,0,0,0,301.94,80.06Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M317.5,78.23l-3.47.65-.87.16-.88.11-1.76.23a.34.34,0,0,0-.33.35l.15,1a.36.36,0,0,0,.42.25l1.8-.24c.3,0,.6-.07.9-.12l.89-.16,3.55-.67a.32.32,0,0,0,.3-.37l-.26-1A.35.35,0,0,0,317.5,78.23Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M433,18.34a.34.34,0,0,0-.37.31l0,1a.37.37,0,0,0,.39.29l3.56-.09v-1.6Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M424.22,19l-1.8.24c-.3,0-.6.07-.9.12l-.89.16-3.55.67a.34.34,0,0,0-.3.38l.26,1a.37.37,0,0,0,.44.21l3.48-.65.86-.17.88-.11,1.76-.23a.34.34,0,0,0,.33-.35l-.15-1A.36.36,0,0,0,424.22,19Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M408.65,22.53c-.58.17-1.13.39-1.69.6l-1.68.63c-.56.21-1.13.41-1.67.64l-1.64.71a.33.33,0,0,0-.2.43l.48.9a.38.38,0,0,0,.48.12l1.6-.71c.53-.22,1.09-.41,1.63-.62l1.64-.61a16.31,16.31,0,0,1,1.66-.58.33.33,0,0,0,.24-.4l-.37-.94A.4.4,0,0,0,408.65,22.53Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M394.25,28.93c-1,.59-2.05,1.16-3.06,1.76l-3,1.88a.3.3,0,0,0-.12.44l.64.82a.39.39,0,0,0,.5,0L392.16,32l3-1.72a.31.31,0,0,0,.15-.44l-.57-.86A.38.38,0,0,0,394.25,28.93Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M369.45,47.15l-2.58,2.29-2.55,2.28a.31.31,0,0,0,0,.46l.76.71a.39.39,0,0,0,.51,0l2.57-2.29,2.55-2.28a.32.32,0,0,0,.05-.46l-.77-.71A.38.38,0,0,0,369.45,47.15Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M381.28,37.44c-.92.7-1.87,1.37-2.76,2.11l-2.71,2.16a.3.3,0,0,0-.06.46l.73.74a.39.39,0,0,0,.51,0l2.68-2.14c.88-.73,1.82-1.39,2.73-2.09a.31.31,0,0,0,.09-.45l-.7-.78A.39.39,0,0,0,381.28,37.44Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M93.13,19.85h7.17a.34.34,0,0,0,.38-.3v-1a.35.35,0,0,0-.38-.3H93.13a.34.34,0,0,0-.38.3v1C92.75,19.72,92.91,19.85,93.13,19.85Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M109,19.85h7.17a.34.34,0,0,0,.38-.3v-1a.35.35,0,0,0-.38-.3H109a.35.35,0,0,0-.38.3v1A.34.34,0,0,0,109,19.85Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M124.87,19.85H132a.34.34,0,0,0,.38-.3v-1a.35.35,0,0,0-.38-.3h-7.17a.35.35,0,0,0-.38.3v1A.34.34,0,0,0,124.87,19.85Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M156.61,19.85h3.58v-1.6h-3.58a.35.35,0,0,0-.38.3v1A.34.34,0,0,0,156.61,19.85Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M140.74,19.85h7.17a.34.34,0,0,0,.38-.3v-1a.35.35,0,0,0-.38-.3h-7.17a.35.35,0,0,0-.38.3v1A.34.34,0,0,0,140.74,19.85Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M5.08,19.85a.34.34,0,0,0,.38-.3v-1a.35.35,0,0,0-.38-.3H1.49v1.6Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M13.77,19.85H21a.34.34,0,0,0,.38-.3v-1a.35.35,0,0,0-.38-.3H13.77a.35.35,0,0,0-.38.3v1A.34.34,0,0,0,13.77,19.85Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M29.64,19.85h7.18a.34.34,0,0,0,.38-.3v-1a.35.35,0,0,0-.38-.3H29.64a.36.36,0,0,0-.38.3v1A.35.35,0,0,0,29.64,19.85Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M45.51,19.85h7.18a.34.34,0,0,0,.38-.3v-1a.35.35,0,0,0-.38-.3H45.51a.35.35,0,0,0-.38.3v1A.34.34,0,0,0,45.51,19.85Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M77.26,19.85h7.17a.34.34,0,0,0,.38-.3v-1a.35.35,0,0,0-.38-.3H77.26a.36.36,0,0,0-.39.3v1C76.87,19.72,77,19.85,77.26,19.85Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M61.39,19.85h7.17a.34.34,0,0,0,.38-.3v-1a.35.35,0,0,0-.38-.3H61.39a.36.36,0,0,0-.39.3v1A.35.35,0,0,0,61.39,19.85Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M636,58.31l-2.71,2.16c-.89.74-1.84,1.41-2.76,2.11a.39.39,0,0,1-.51,0l-.69-.77a.3.3,0,0,1,.08-.45c.91-.7,1.85-1.36,2.73-2.09l2.68-2.14a.39.39,0,0,1,.51,0l.74.74A.31.31,0,0,1,636,58.31Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M623.59,67.45l-3,1.87c-1,.6-2,1.17-3.07,1.76a.37.37,0,0,1-.49-.07l-.57-.86a.31.31,0,0,1,.15-.44c1-.57,2-1.13,3-1.72l2.93-1.85a.39.39,0,0,1,.5,0l.64.81A.31.31,0,0,1,623.59,67.45Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M609.83,74.89l-1.63.72c-.55.23-1.12.43-1.68.64l-1.67.63c-.56.21-1.12.43-1.7.59a.37.37,0,0,1-.47-.17l-.38-.94a.32.32,0,0,1,.25-.39c.56-.16,1.1-.38,1.65-.58l1.64-.61c.55-.21,1.1-.4,1.64-.63l1.59-.7a.39.39,0,0,1,.49.12l.48.9A.32.32,0,0,1,609.83,74.89Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M578.83,81.66l-3.62.09v-1.6l3.56-.09a.36.36,0,0,1,.39.29l0,1C579.21,81.52,579.05,81.66,578.83,81.66Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M594.72,79.78l-3.55.67-.89.16c-.3,0-.6.08-.9.12l-1.79.24c-.21,0-.41-.09-.43-.25l-.15-1a.35.35,0,0,1,.33-.35l1.76-.23L590,79l.87-.16,3.47-.65a.35.35,0,0,1,.44.21l.26,1A.32.32,0,0,1,594.72,79.78Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M709.86,19.94a.37.37,0,0,1-.4-.29l0-1a.34.34,0,0,1,.37-.31l3.62-.09v1.6Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M701.28,20.62l-1.76.23-.87.11-.87.17-3.48.65a.37.37,0,0,1-.44-.21l-.26-1a.34.34,0,0,1,.3-.38l3.55-.67.89-.16c.3-.05.6-.08.9-.12L701,19a.36.36,0,0,1,.42.25l.15,1A.34.34,0,0,1,701.28,20.62Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M686.08,24a16.31,16.31,0,0,0-1.66.58l-1.64.61c-.54.21-1.09.4-1.63.62l-1.6.71a.38.38,0,0,1-.48-.12l-.48-.9a.33.33,0,0,1,.2-.43l1.64-.71c.55-.23,1.11-.43,1.67-.64l1.68-.63c.56-.21,1.11-.43,1.69-.6a.4.4,0,0,1,.48.17l.37.94A.33.33,0,0,1,686.08,24Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M672,30.3c-1,.57-2,1.14-3,1.72l-2.93,1.85a.39.39,0,0,1-.5,0l-.64-.82a.3.3,0,0,1,.12-.44l3-1.88c1-.6,2-1.17,3.06-1.76a.38.38,0,0,1,.5.07l.57.86A.31.31,0,0,1,672,30.3Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M647.49,48.3l-2.55,2.28-2.57,2.29a.39.39,0,0,1-.51,0l-.76-.71a.31.31,0,0,1,0-.46l2.55-2.28,2.58-2.29a.38.38,0,0,1,.5,0l.77.71A.31.31,0,0,1,647.49,48.3Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M659.22,38.67c-.91.7-1.85,1.36-2.73,2.09l-2.68,2.14a.38.38,0,0,1-.5,0l-.74-.74a.31.31,0,0,1,.07-.46l2.7-2.16c.89-.74,1.84-1.41,2.76-2.11a.39.39,0,0,1,.51,0l.7.78A.31.31,0,0,1,659.22,38.67Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M515.6,57.12l2.68,2.14c.88.73,1.82,1.39,2.73,2.09a.3.3,0,0,1,.09.45l-.7.77a.38.38,0,0,1-.5,0c-.92-.7-1.88-1.37-2.77-2.11l-2.7-2.16a.31.31,0,0,1-.07-.46l.74-.74A.38.38,0,0,1,515.6,57.12Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M527.86,66.14,530.78,68c1,.59,2,1.15,3,1.72a.32.32,0,0,1,.15.44l-.57.86a.39.39,0,0,1-.5.07c-1-.59-2-1.16-3.06-1.76l-3-1.87a.31.31,0,0,1-.13-.45l.65-.81A.39.39,0,0,1,527.86,66.14Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M541.35,73.45l1.6.7c.54.23,1.09.42,1.63.63l1.64.61c.55.2,1.09.42,1.66.58a.32.32,0,0,1,.24.39l-.37.94a.39.39,0,0,1-.48.17c-.58-.16-1.13-.38-1.69-.59l-1.68-.63c-.56-.21-1.12-.41-1.67-.64l-1.64-.72a.31.31,0,0,1-.2-.42l.48-.9A.37.37,0,0,1,541.35,73.45Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M571.66,80.06l3.55.09v1.6l-3.62-.09a.34.34,0,0,1-.37-.31l0-1C571.27,80.19,571.45,80.06,571.66,80.06Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M556.11,78.23l3.47.65.87.16.88.11,1.75.23c.21,0,.36.18.33.35l-.14,1a.38.38,0,0,1-.43.25l-1.8-.24c-.3,0-.6-.07-.89-.12l-.89-.16-3.56-.67a.32.32,0,0,1-.3-.37l.26-1A.37.37,0,0,1,556.11,78.23Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M449.39,19l1.79.24.9.12.89.16,3.56.67a.32.32,0,0,1,.29.38l-.26,1c0,.16-.23.24-.44.21l-3.47-.65-.87-.17-.88-.11-1.76-.23c-.2,0-.35-.18-.32-.35l.14-1A.38.38,0,0,1,449.39,19Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M465,22.53c.58.17,1.14.39,1.7.6l1.68.63c.55.21,1.12.41,1.67.64l1.63.71a.33.33,0,0,1,.21.43l-.48.9a.4.4,0,0,1-.49.12l-1.59-.71c-.54-.22-1.09-.41-1.64-.62L466,24.62a17,17,0,0,0-1.65-.58c-.2-.07-.31-.24-.25-.4l.38-.94A.38.38,0,0,1,465,22.53Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M479.35,28.93c1,.59,2,1.16,3.06,1.76l3,1.88a.31.31,0,0,1,.13.44l-.65.82a.39.39,0,0,1-.5,0L481.44,32c-1-.58-2-1.15-3-1.72a.33.33,0,0,1-.15-.44l.57-.86A.39.39,0,0,1,479.35,28.93Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M504.16,47.15l2.57,2.29,2.56,2.28a.31.31,0,0,1,0,.46l-.77.71a.38.38,0,0,1-.5,0l-2.57-2.29-2.56-2.28a.31.31,0,0,1,0-.46l.76-.71A.39.39,0,0,1,504.16,47.15Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M492.32,37.44c.92.7,1.88,1.37,2.77,2.11l2.7,2.16a.31.31,0,0,1,.07.46l-.74.74a.39.39,0,0,1-.51,0l-2.67-2.14c-.89-.73-1.83-1.39-2.74-2.09a.3.3,0,0,1-.08-.45l.7-.78A.38.38,0,0,1,492.32,37.44Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M912.39,58.31l-2.7,2.16c-.89.74-1.85,1.41-2.77,2.11a.38.38,0,0,1-.5,0l-.7-.77a.3.3,0,0,1,.09-.45c.91-.7,1.85-1.36,2.73-2.09l2.68-2.14a.38.38,0,0,1,.5,0l.74.74A.31.31,0,0,1,912.39,58.31Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M900,67.45l-3,1.87c-1,.6-2,1.17-3.06,1.76a.39.39,0,0,1-.5-.07l-.57-.86a.33.33,0,0,1,.15-.44c1-.57,2-1.13,3-1.72L899,66.14a.39.39,0,0,1,.5,0l.65.81A.31.31,0,0,1,900,67.45Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M886.23,74.89l-1.63.72c-.56.23-1.12.43-1.68.64l-1.68.63c-.56.21-1.11.43-1.69.59a.39.39,0,0,1-.48-.17l-.37-.94a.32.32,0,0,1,.24-.39c.57-.16,1.11-.38,1.66-.58l1.64-.61c.54-.21,1.09-.4,1.63-.63l1.6-.7a.37.37,0,0,1,.48.12l.48.9A.31.31,0,0,1,886.23,74.89Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M855.23,81.66l-3.62.09v-1.6l3.55-.09a.37.37,0,0,1,.4.29l0,1A.34.34,0,0,1,855.23,81.66Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M871.12,79.78l-3.56.67-.88.16c-.3,0-.6.08-.9.12L864,81a.36.36,0,0,1-.42-.25l-.15-1c0-.17.12-.32.33-.35l1.76-.23.87-.11.87-.16,3.48-.65a.35.35,0,0,1,.44.21l.26,1A.32.32,0,0,1,871.12,79.78Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M986.25,19.94a.36.36,0,0,1-.39-.29l-.05-1a.34.34,0,0,1,.38-.31l3.62-.09v1.6Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M977.68,20.62l-1.76.23L975,21l-.87.17-3.47.65a.37.37,0,0,1-.44-.21l-.26-1a.34.34,0,0,1,.3-.38l3.55-.67.89-.16c.3-.05.6-.08.9-.12l1.79-.24a.38.38,0,0,1,.43.25l.15,1A.35.35,0,0,1,977.68,20.62Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M962.47,24a17,17,0,0,0-1.65.58l-1.64.61c-.54.21-1.1.4-1.63.62l-1.6.71a.4.4,0,0,1-.49-.12l-.48-.9a.34.34,0,0,1,.21-.43l1.63-.71c.55-.23,1.12-.43,1.68-.64l1.67-.63c.57-.21,1.12-.43,1.7-.6a.38.38,0,0,1,.47.17l.38.94C962.78,23.8,962.67,24,962.47,24Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M948.39,30.3c-1,.57-2,1.14-3,1.72l-2.92,1.85a.39.39,0,0,1-.5,0l-.65-.82a.31.31,0,0,1,.13-.44l3-1.88c1-.6,2-1.17,3.06-1.76a.39.39,0,0,1,.5.07l.57.86A.32.32,0,0,1,948.39,30.3Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M923.89,48.3l-2.55,2.28-2.58,2.29a.38.38,0,0,1-.5,0l-.77-.71a.31.31,0,0,1,0-.46l2.55-2.28,2.57-2.29a.39.39,0,0,1,.51,0l.76.71A.31.31,0,0,1,923.89,48.3Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M935.62,38.67c-.91.7-1.85,1.36-2.73,2.09l-2.68,2.14a.39.39,0,0,1-.51,0l-.73-.74a.3.3,0,0,1,.06-.46l2.71-2.16c.89-.74,1.84-1.41,2.76-2.11a.39.39,0,0,1,.51,0l.69.78A.3.3,0,0,1,935.62,38.67Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M792,57.12l2.68,2.14c.88.73,1.82,1.39,2.73,2.09a.31.31,0,0,1,.09.45l-.7.77a.39.39,0,0,1-.51,0c-.92-.7-1.87-1.37-2.76-2.11l-2.71-2.16a.3.3,0,0,1-.06-.46l.73-.74A.39.39,0,0,1,792,57.12Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M804.25,66.14,807.18,68c1,.59,2,1.15,3,1.72a.31.31,0,0,1,.14.44l-.56.86a.39.39,0,0,1-.5.07c-1-.59-2-1.16-3.07-1.76l-3-1.87a.31.31,0,0,1-.12-.45l.64-.81A.39.39,0,0,1,804.25,66.14Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M817.75,73.45l1.59.7c.54.23,1.1.42,1.64.63l1.64.61c.55.2,1.09.42,1.65.58a.32.32,0,0,1,.25.39l-.37.94a.39.39,0,0,1-.48.17c-.58-.16-1.13-.38-1.7-.59l-1.67-.63c-.56-.21-1.13-.41-1.68-.64L817,74.89a.31.31,0,0,1-.2-.42l.47-.9A.39.39,0,0,1,817.75,73.45Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M848.06,80.06l3.55.09v1.6L848,81.66a.34.34,0,0,1-.37-.31l0-1A.37.37,0,0,1,848.06,80.06Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M832.5,78.23l3.47.65.87.16.88.11,1.76.23a.34.34,0,0,1,.33.35l-.15,1a.36.36,0,0,1-.42.25l-1.8-.24-.9-.12-.89-.16-3.55-.67a.32.32,0,0,1-.3-.37l.26-1A.35.35,0,0,1,832.5,78.23Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M717,18.34a.34.34,0,0,1,.37.31l0,1a.37.37,0,0,1-.39.29l-3.56-.09v-1.6Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M725.78,19l1.8.24.9.12.89.16,3.55.67a.34.34,0,0,1,.3.38l-.26,1a.37.37,0,0,1-.44.21L729,21.13l-.86-.17-.88-.11-1.76-.23a.34.34,0,0,1-.33-.35l.15-1A.36.36,0,0,1,725.78,19Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M741.35,22.53c.58.17,1.13.39,1.69.6l1.68.63c.56.21,1.13.41,1.67.64l1.64.71a.33.33,0,0,1,.2.43l-.48.9a.38.38,0,0,1-.48.12l-1.6-.71c-.53-.22-1.09-.41-1.63-.62l-1.64-.61a16.31,16.31,0,0,0-1.66-.58.33.33,0,0,1-.24-.4l.37-.94A.4.4,0,0,1,741.35,22.53Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M755.75,28.93c1,.59,2,1.16,3.06,1.76l3,1.88a.3.3,0,0,1,.12.44l-.64.82a.39.39,0,0,1-.5,0L757.84,32l-3-1.72a.31.31,0,0,1-.15-.44l.57-.86A.38.38,0,0,1,755.75,28.93Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M780.55,47.15l2.58,2.29,2.55,2.28a.31.31,0,0,1,0,.46l-.76.71a.39.39,0,0,1-.51,0l-2.57-2.29-2.55-2.28a.32.32,0,0,1-.05-.46l.77-.71A.38.38,0,0,1,780.55,47.15Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M768.72,37.44c.92.7,1.87,1.37,2.76,2.11l2.71,2.16a.3.3,0,0,1,.06.46l-.73.74a.39.39,0,0,1-.51,0l-2.68-2.14c-.88-.73-1.82-1.39-2.73-2.09a.31.31,0,0,1-.09-.45l.7-.78A.39.39,0,0,1,768.72,37.44Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M1056.87,19.85h-7.17a.34.34,0,0,1-.38-.3v-1a.35.35,0,0,1,.38-.3h7.17a.34.34,0,0,1,.38.3v1C1057.25,19.72,1057.09,19.85,1056.87,19.85Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M1041,19.85h-7.17a.34.34,0,0,1-.38-.3v-1a.35.35,0,0,1,.38-.3H1041a.35.35,0,0,1,.38.3v1A.34.34,0,0,1,1041,19.85Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M1025.13,19.85H1018a.34.34,0,0,1-.38-.3v-1a.35.35,0,0,1,.38-.3h7.17a.35.35,0,0,1,.38.3v1A.34.34,0,0,1,1025.13,19.85Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M993.39,19.85h-3.58v-1.6h3.58a.35.35,0,0,1,.38.3v1A.34.34,0,0,1,993.39,19.85Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M1009.26,19.85h-7.17a.34.34,0,0,1-.38-.3v-1a.35.35,0,0,1,.38-.3h7.17a.35.35,0,0,1,.38.3v1A.34.34,0,0,1,1009.26,19.85Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M1144.92,19.85a.34.34,0,0,1-.38-.3v-1a.35.35,0,0,1,.38-.3h3.59v1.6Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M1136.23,19.85h-7.18a.34.34,0,0,1-.38-.3v-1a.35.35,0,0,1,.38-.3h7.18a.35.35,0,0,1,.38.3v1A.34.34,0,0,1,1136.23,19.85Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M1120.36,19.85h-7.18a.34.34,0,0,1-.38-.3v-1a.35.35,0,0,1,.38-.3h7.18a.36.36,0,0,1,.38.3v1A.35.35,0,0,1,1120.36,19.85Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M1104.49,19.85h-7.18a.34.34,0,0,1-.38-.3v-1a.35.35,0,0,1,.38-.3h7.18a.35.35,0,0,1,.38.3v1A.34.34,0,0,1,1104.49,19.85Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M1072.74,19.85h-7.17a.34.34,0,0,1-.38-.3v-1a.35.35,0,0,1,.38-.3h7.17a.36.36,0,0,1,.39.3v1C1073.13,19.72,1073,19.85,1072.74,19.85Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M1088.61,19.85h-7.17a.34.34,0,0,1-.38-.3v-1a.35.35,0,0,1,.38-.3h7.17a.36.36,0,0,1,.39.3v1A.35.35,0,0,1,1088.61,19.85Z"
})))));

var SvgImgPath = function SvgImgPath(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1150 100",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImgPath, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/img-path.3cba38c5.svg";
export { ForwardRef as ReactComponent };